import { RootState } from "../../store";

export const getCardSelector = (state: RootState) => state.getCards;
